export const stateCoordinates = {
    "Acre": { lat: -9.0477, lng: -70.5260 },
    "Alagoas": { lat: -9.6612, lng: -36.6502 },
    "Amapá": { lat: 0.9026, lng: -52.0036 },
    "Amazonas": { lat: -3.4168, lng: -65.8561 },
    "Bahia": { lat: -12.5797, lng: -41.7007 },
    "Ceará": { lat: -5.4984, lng: -39.3206 },
    "Distrito Federal": { lat: -15.7942, lng: -47.8825 },
    "Espírito Santo": { lat: -19.1834, lng: -40.3089 },
    "Goiás": { lat: -15.8270, lng: -49.8362 },
    "Maranhão": { lat: -5.0903, lng: -45.0062 },
    "Mato Grosso": { lat: -12.6819, lng: -56.9211 },
    "Mato Grosso do Sul": { lat: -20.7722, lng: -54.7852 },
    "Minas Gerais": { lat: -18.5122, lng: -44.5550 },
    "Pará": { lat: -3.4168, lng: -52.0023 },
    "Paraíba": { lat: -7.1219, lng: -36.7241 },
    "Paraná": { lat: -25.2521, lng: -52.0215 },
    "Pernambuco": { lat: -8.8137, lng: -36.9541 },
    "Piauí": { lat: -7.6996, lng: -42.5043 },
    "Rio de Janeiro": { lat: -22.9068, lng: -43.1729 },
    "Rio Grande do Norte": { lat: -5.4026, lng: -36.9541 },
    "Rio Grande do Sul": { lat: -30.0346, lng: -51.2177 },
    "Rondônia": { lat: -11.5057, lng: -63.5806 },
    "Roraima": { lat: 2.7376, lng: -62.0751 },
    "Santa Catarina": { lat: -27.5954, lng: -48.5480 },
    "São Paulo": { lat: -23.5505, lng: -46.6333 },
    "Sergipe": { lat: -10.9472, lng: -37.0731 },
    "Tocantins": { lat: -10.1753, lng: -48.2982 }
};
export const favoriteAttractionFozDoIguacuCoordinates = {
    "Cataratas": { lat: -25.69265054311462, lng: -54.43453716125831 },
    "Parque das Aves": { lat: -25.613658838457862, lng: -54.59023360359129 },
    "Marco das Três Fronteiras": { lat: -25.590003825581004, lng: -54.59023360359129 },
    "Itaipu": { lat: -25.407652986645644, lng: -54.58681103451447 },
    "Dreans": { lat: -25.590703697608784, lng: -54.51710033242643 },
    "Macuco Safari": { lat: -25.648041026363714, lng: -54.4577258237053 },
    "Templo Budista": { lat: -25.473755518455125, lng: -54.59911144592492 },
    "Mesquita Árabe": { lat: -25.520390172696732, lng: -54.57868064592344 },
    "Wonders": { lat: -25.608904480245478, lng: -454.48937213242596 },
    "Katamaram": { lat: -25.59020977311838, lng: -54.57875314592123 },
    "Helisul": { lat: -25.61264996381079, lng: -54.48150461708528 },
    "Aquamania": { lat: -25.58242054773743, lng: -54.52785556789445 },
    "Bluepark": { lat: -25.565967553628372, lng: -54.55161940359213 },
};
